<div class="gw-flex gw-flex-col">
  <gatewee-input-v2
    [id]="'withdrawal-pix-recipient'"
    [form]="form"
    controlName="pixKey"
    [iconName]="recipientInputIconName"
    [label]="'features.withdrawals.modalPix.recipientFieldLabel' | translate"
    [placeholder]="
      'features.withdrawals.modalPix.smartRecipientPlaceholder' | translate
    "
    [mask]="recipientMask"
    [type]="recipientInputType"
    [customMessages]="pixKeyCustomMessages"
    (focus)="pixKeyFocus.emit()"
    (blur)="pixKeyBlur.emit()"
  ></gatewee-input-v2>

  <div
    *ngIf="pixKeyFieldShowsError"
    class="gw-h-[26px] gw-shrink-0"
    aria-hidden="true"
  ></div>

  <p
    *ngIf="recipientKindHint"
    class="gw-text-text-secondary gw-text-xs gw-mb-0"
    [class.gw-mt-1]="!pixKeyFieldShowsError"
    [class.gw-mt-2]="pixKeyFieldShowsError"
  >
    {{ recipientKindHint }}
  </p>

  <div
    *ngIf="showAmbiguousKindRow"
    class="gw-mt-2 gw-flex gw-flex-wrap gw-items-center gw-gap-2"
  >
    <span class="gw-text-text-secondary gw-text-xs gw-font-medium gw-m-0">
      {{ 'features.withdrawals.modalPix.kindAmbiguousPrompt' | translate }}
    </span>
    <button
      type="button"
      class="gw-inline-flex gw-items-center gw-rounded-full gw-border gw-border-border-normal gw-bg-background-elevation-1 gw-px-3 gw-py-1 gw-text-xs gw-font-semibold gw-text-text-primary hover:gw-bg-background-neutral-1 gw-cursor-pointer"
      [class.gw-border-background-accent-1]="manualPixKeyKind === 'cpf'"
      (click)="kindPicked.emit('cpf')"
    >
      {{ 'features.withdrawals.modalPix.kindChipCpf' | translate }}
    </button>
    <button
      type="button"
      class="gw-inline-flex gw-items-center gw-rounded-full gw-border gw-border-border-normal gw-bg-background-elevation-1 gw-px-3 gw-py-1 gw-text-xs gw-font-semibold gw-text-text-primary hover:gw-bg-background-neutral-1 gw-cursor-pointer"
      [class.gw-border-background-accent-1]="manualPixKeyKind === 'phone'"
      (click)="kindPicked.emit('phone')"
    >
      {{ 'features.withdrawals.modalPix.kindChipPhone' | translate }}
    </button>
  </div>

  <p
    *ngIf="lookupPending"
    class="gw-text-text-secondary gw-text-xs gw-mb-0 gw-mt-2"
  >
    {{
      'features.withdrawals.modalPix.recipientVerificationPending' | translate
    }}
  </p>

  <p
    *ngIf="lookupErrorMessage && !lookupPending"
    class="gw-text-status-negative gw-text-xs gw-mb-0 gw-mt-2"
  >
    {{ lookupErrorMessage }}
  </p>

  <div *ngIf="bankAccountsLoading" class="gw-mt-medium gw-w-full">
    <gatewee-skeleton></gatewee-skeleton>
  </div>

  <div
    *ngIf="!contactSearchQuery && defaultBankAccount"
    class="gw-mt-medium gw-w-full"
  >
    <span
      class="gw-text-text-secondary gw-text-base gw-font-normal gw-block gw-mb-small"
    >
      {{ 'features.withdrawals.modalPix.frequentPayees' | translate }}
    </span>
    <div class="gw-flex gw-w-full gw-justify-center gw-gap-medium">
      <button
        type="button"
        class="gw-flex gw-max-w-[33%] gw-flex-[1_1_0] gw-flex-col gw-items-center gw-gap-2 gw-border-0 gw-bg-transparent gw-p-0"
        [class.gw-cursor-pointer]="isBankAccountSelectable(defaultBankAccount)"
        [class.gw-cursor-not-allowed]="
          !isBankAccountSelectable(defaultBankAccount)
        "
        [class.gw-opacity-50]="!isBankAccountSelectable(defaultBankAccount)"
        [disabled]="!isBankAccountSelectable(defaultBankAccount)"
        [attr.aria-disabled]="!isBankAccountSelectable(defaultBankAccount)"
        (click)="onContactClick(defaultBankAccount)"
      >
        <tui-avatar
          class="gw-h-[52px] gw-w-[52px] gw-shrink-0 gw-border-base-neutral gw-bg-background-elevation-2"
          [round]="true"
          [src]="defaultBankAccount.holderName || '' | tuiInitials"
          [style.color]="'var(--tui-background-accent-1)'"
          [style.fontWeight]="'bold'"
        ></tui-avatar>
        <span class="gw-text-center gw-font-extrabold gw-text-text-primary">{{
          defaultBankAccount.holderName
        }}</span>
        <span class="gw-text-center gw-text-text-secondary gw-font-normal">{{
          bankDisplayNameForAccount(defaultBankAccount)
        }}</span>
        <span
          *ngIf="!isBankAccountSelectable(defaultBankAccount)"
          class="gw-text-center gw-text-xs gw-text-text-tertiary"
        >
          {{ statusLabelKey(defaultBankAccount) | translate }}
        </span>
      </button>
    </div>
  </div>

  <div
    *ngIf="
      contactSearchQuery && !bankAccountsLoading && bankAccounts.length === 0
    "
    class="gw-mt-medium gw-w-full gw-rounded-xl gw-border gw-border-border-normal gw-bg-background-elevation-1 gw-px-medium gw-py-medium gw-text-center"
  >
    <span class="gw-text-text-secondary gw-text-sm">{{
      'features.withdrawals.modalPix.contactsNoMatch' | translate
    }}</span>
  </div>

  <div
    *ngIf="!bankAccountsLoading && bankAccounts.length > 0"
    class="gw-mt-medium gw-w-full"
  >
    <span
      class="gw-text-text-secondary gw-text-base gw-font-normal gw-block gw-mb-small"
    >
      {{
        (contactSearchQuery
          ? 'features.withdrawals.modalPix.matchingContacts'
          : 'features.withdrawals.modalPix.allContacts'
        ) | translate
      }}
    </span>
    <div class="gw-flex gw-flex-col">
      <ng-container *ngFor="let account of bankAccounts; let i = index">
        <button
          type="button"
          class="gw-flex gw-w-full gw-items-center gw-gap-small gw-border-0 gw-bg-transparent gw-py-2 gw-pl-2 gw-pr-2 gw-text-left"
          [ngClass]="
            isBankAccountSelectable(account)
              ? 'gw-cursor-pointer hover:gw-bg-background-neutral-1'
              : 'gw-cursor-not-allowed gw-opacity-50'
          "
          [disabled]="!isBankAccountSelectable(account)"
          [attr.aria-disabled]="!isBankAccountSelectable(account)"
          (click)="onContactClick(account)"
        >
          <tui-avatar
            class="gw-h-[52px] gw-w-[52px] gw-shrink-0 gw-border-base-neutral gw-bg-background-elevation-2"
            [round]="true"
            [src]="account.holderName || '' | tuiInitials"
            [style.color]="'var(--tui-background-accent-1)'"
            [style.fontWeight]="'bold'"
          ></tui-avatar>
          <div class="gw-min-w-0 gw-flex-1 gw-flex-col">
            <span
              class="gw-block gw-truncate gw-font-extrabold gw-uppercase gw-text-text-primary"
              >{{ account.holderName | uppercase }}</span
            >
            <span
              class="gw-block gw-truncate gw-text-text-secondary gw-font-normal"
              >{{ bankDisplayNameForAccount(account) }}</span
            >
            <span
              *ngIf="!isBankAccountSelectable(account)"
              class="gw-block gw-truncate gw-text-xs gw-text-text-tertiary"
            >
              {{ statusLabelKey(account) | translate }}
            </span>
          </div>
          <gatewee-icon
            *ngIf="isBankAccountSelectable(account)"
            icon="@phi.caret-right"
            iconStyle="primary"
            size="16px"
            class="gw-shrink-0"
          ></gatewee-icon>
        </button>
        <div
          class="gw-my-2 gw-h-px gw-w-full gw-bg-border-normal"
          aria-hidden="true"
        ></div>
      </ng-container>
    </div>
  </div>
</div>
